// frontend/src/store/moduleDrawerStore.ts
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface ModuleDrawerState {
  open: boolean;
  toggle: () => void;
  setOpen: (open: boolean) => void;
}

export const useModuleDrawerStore = create<ModuleDrawerState>()(
  persist(
    (set) => ({
      open: false,
      toggle: () => set(state => ({ open: !state.open })),
      setOpen: (open) => set({ open }),
    }),
    { name: 'moduleDrawer.open' }
  )
);
